import React, { Component } from 'react';
import { getDistance } from 'geolib';

export default class Distance extends Component {
	state = {
		destinationLat: 25.810331,
		destinationLong: 90.412521,
		distance: null,
		pdDistance: null,
		startLat: 26.810331,
		startLong: 90.412521,
	};
	async componentWillReceiveProps(newProps) {
		const { originLatLng, distLatLng, getDistanceValue } = await newProps;

		if (originLatLng && distLatLng) {
			this.setState({
				destinationLat: distLatLng.lat,
				destinationLong: distLatLng.lng,
				startLat: originLatLng.lat,
				startLong: originLatLng.lng,
			});
		}

		let dis = getDistance(
			{
				latitude: this.state.startLat,
				longitude: this.state.startLong,
			},
			{
				latitude: this.state.destinationLat,
				longitude: this.state.destinationLong,
			}
		);

		let distanceValue = Number.parseFloat(dis / 620).toFixed(2);

		this.setState({
			distance: distanceValue,
		});
		getDistanceValue(this.state.distance);
	}

	render() {
		return (
			<div>
				<h4>{this.state.distance} km</h4>
			</div>
		);
	}
}

//lat: 24.810331, lng: 90.412521
//lat: 26.810331, lng: 90.412521
